import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaHover from './VaHover.vue'

export default withConfigTransport(VaHover)
